export default "__VITE_ASSET__BaT4Ew3w__"